// extracted by mini-css-extract-plugin
export default {"container":"FeatureCard_container__etwRT","imageContainer":"FeatureCard_imageContainer__nhtmV","content":"FeatureCard_content__ZXx4s","description":"FeatureCard_description__v0dZb"};